import {
  Component,
  Input,
  HostListener,
  Output,
  EventEmitter,
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  FormsModule,
} from '@angular/forms';
import { InputComponent } from '../input/input.component';
import { CommonModule } from '@angular/common';
import { ValidationErrors } from '@angular/forms';

@Component({
  selector: 'app-input-mock',
  standalone: true,
  templateUrl: './input-mock.component.html',
  styleUrls: ['./input-mock.component.scss'],
  imports: [CommonModule, InputComponent, FormsModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: InputMockComponent,
      multi: true,
    },
  ],
})
export class InputMockComponent implements ControlValueAccessor {
  @Input() placeholder: string = '';
  @Input() label: string = '';
  @Input() leftIcon: string = '';
  @Input() rightIcon: string = '';

  @Input() required?: boolean;
  @Input() errorMessage?: ValidationErrors | null;
  @Input() touched?: boolean;

  @Output() onClick = new EventEmitter<MouseEvent>();

  @Input()
  set value(val: any) {
    this._value = val;
    this.onChange(val);
  }
  get value() {
    return this._value;
  }
  private _value: any = '';

  onChange = (value: any) => {};
  onTouched = () => {};

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {}

  onInputChange(value: any) {
    this.value = value;
    this.onChange(value);
    this.onTouched();
  }

  @HostListener('click', ['$event'])
  onClickHost(evt: MouseEvent) {
    this.onClick.emit(evt);
  }
}
